import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { ReseptioLogoFull } from '../components/ReseptioLogo';

const QUICK_MESSAGES = [
  'Bu hafta sonu müsait oda var mı?',
  'Fiyatlarınız ne kadar?',
  'Rezervasyon yapmak istiyorum',
  'Check-in saati ne zaman?',
];

function DemoBot() {
  const [messages, setMessages] = useState([
    { role: 'assistant', content: 'Merhaba! 👋 Ben Marina Butik Otel\'in dijital resepsiyonistiyim. Size nasıl yardımcı olabilirim?' },
  ]);
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const [limitReached, setLimitReached] = useState(false);
  const [remaining, setRemaining] = useState(10);
  const sessionId = useRef('demo-' + Math.random().toString(36).slice(2));
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const send = async (text) => {
    const msg = text || input.trim();
    if (!msg || sending || limitReached) return;
    setInput('');
    setSending(true);
    setMessages(prev => [...prev, { role: 'user', content: msg }]);

    try {
      const history = messages.map(m => ({ role: m.role, content: m.content }));
      const data = await api.post('/demo/chat', {
        sessionId: sessionId.current,
        message: msg,
        history,
      });
      if (data.limitReached) {
        setLimitReached(true);
        setMessages(prev => [...prev, {
          role: 'assistant',
          content: '✋ Demo oturum limiti doldu. 7 günlük ücretsiz hesap açarak tüm özellikleri deneyebilirsiniz.',
        }]);
      } else {
        setRemaining(data.remaining);
        setMessages(prev => [...prev, { role: 'assistant', content: data.reply }]);
      }
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: 'Bağlantı hatası, lütfen tekrar deneyin.' }]);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{
      background: 'white', borderRadius: 20, boxShadow: '0 8px 40px rgba(0,0,0,0.12)',
      overflow: 'hidden', display: 'flex', flexDirection: 'column', height: 480, width: '100%', maxWidth: 420,
    }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🌊</div>
        <div>
          <div style={{ color: 'white', fontWeight: 700, fontSize: 14 }}>Marina Butik Otel</div>
          <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12 }}>Dijital Resepsiyonist · Demo</div>
        </div>
        {remaining < 10 && !limitReached && (
          <div style={{ marginLeft: 'auto', fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>{remaining} mesaj kaldı</div>
        )}
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10, background: '#f8fafc' }}>
        {messages.map((m, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start' }}>
            <div style={{
              maxWidth: '80%', padding: '10px 14px', borderRadius: m.role === 'user' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
              background: m.role === 'user' ? 'linear-gradient(135deg, #6366f1, #8b5cf6)' : 'white',
              color: m.role === 'user' ? 'white' : '#1e293b',
              fontSize: 13, lineHeight: 1.5,
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            }}>
              {m.content}
            </div>
          </div>
        ))}
        {sending && (
          <div style={{ display: 'flex', gap: 4, padding: '10px 14px' }}>
            {[0,1,2].map(i => (
              <div key={i} style={{ width: 6, height: 6, borderRadius: '50%', background: '#94a3b8', animation: `bounce 1s ${i*0.2}s infinite` }} />
            ))}
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      {/* Quick replies */}
      {messages.length <= 2 && !limitReached && (
        <div style={{ padding: '8px 12px', display: 'flex', gap: 6, flexWrap: 'wrap', background: 'white', borderTop: '1px solid #f1f5f9' }}>
          {QUICK_MESSAGES.map(q => (
            <button key={q} onClick={() => send(q)} style={{
              fontSize: 11, padding: '5px 10px', borderRadius: 20,
              background: '#f1f5f9', border: '1px solid #e2e8f0', color: '#475569',
              cursor: 'pointer', whiteSpace: 'nowrap',
            }}>{q}</button>
          ))}
        </div>
      )}

      {/* Input */}
      <div style={{ padding: '10px 12px', display: 'flex', gap: 8, background: 'white', borderTop: '1px solid #f1f5f9' }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && send()}
          placeholder={limitReached ? 'Demo limiti doldu' : 'Mesaj yazın...'}
          disabled={limitReached || sending}
          style={{
            flex: 1, padding: '9px 14px', borderRadius: 24, border: '1px solid #e2e8f0',
            fontSize: 13, outline: 'none', background: limitReached ? '#f8fafc' : 'white',
          }}
        />
        <button
          onClick={() => send()}
          disabled={!input.trim() || sending || limitReached}
          style={{
            width: 38, height: 38, borderRadius: '50%', border: 'none',
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: 'white',
            cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
            opacity: (!input.trim() || sending || limitReached) ? 0.5 : 1,
          }}
        >➤</button>
      </div>
    </div>
  );
}

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: 'Inter, -apple-system, sans-serif', color: '#0f172a', overflowX: 'hidden' }}>
      <style>{`
        @keyframes bounce { 0%,80%,100%{transform:translateY(0)} 40%{transform:translateY(-6px)} }
        @keyframes fadeUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
        .fade-up { animation: fadeUp 0.6s ease both; }
        .feature-card:hover { transform: translateY(-4px); box-shadow: 0 12px 40px rgba(0,0,0,0.1) !important; }
        .feature-card { transition: all 0.25s ease; }
        .cta-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(99,102,241,0.4) !important; }
        .cta-btn { transition: all 0.2s ease; }
      `}</style>

      {/* NAV */}
      <nav style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid #e2e8f0', padding: '0 32px', height: 60,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <ReseptioLogoFull height={30} />
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <button onClick={() => navigate('/login')} style={{ background: 'none', border: '1px solid #e2e8f0', borderRadius: 8, padding: '7px 16px', fontSize: 14, color: '#475569', cursor: 'pointer', fontWeight: 600 }}>
            Giriş Yap
          </button>
          <button onClick={() => navigate('/register')} className="cta-btn" style={{
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', border: 'none',
            borderRadius: 8, padding: '8px 18px', fontSize: 14, color: 'white', cursor: 'pointer', fontWeight: 700,
            boxShadow: '0 4px 14px rgba(99,102,241,0.3)',
          }}>
            Ücretsiz Dene
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section style={{
        background: 'linear-gradient(135deg, #f8f7ff 0%, #ede9fe 50%, #f0f9ff 100%)',
        padding: '80px 32px 64px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: 64, flexWrap: 'wrap', minHeight: '85vh',
      }}>
        <div style={{ maxWidth: 520, flex: 1 }} className="fade-up">
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#ede9fe', borderRadius: 20, padding: '5px 14px', marginBottom: 20 }}>
            <span style={{ fontSize: 16 }}>✨</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#7c3aed' }}>WhatsApp + Instagram entegrasyonu</span>
          </div>
          <h1 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 900, lineHeight: 1.15, marginBottom: 20, letterSpacing: '-0.02em' }}>
            Otelinizin{' '}
            <span style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              7/24 Çalışan
            </span>{' '}
            Dijital Resepsiyonisti
          </h1>
          <p style={{ fontSize: 18, color: '#475569', lineHeight: 1.7, marginBottom: 32 }}>
            Misafir sorularını saniyeler içinde yanıtlar, rezervasyon alır, oda görsellerini gönderir.
            Resepsiyonunuz uyurken bile botunuz çalışmaya devam eder.
          </p>
          <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
            <button onClick={() => navigate('/register')} className="cta-btn" style={{
              background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', border: 'none',
              borderRadius: 12, padding: '14px 28px', fontSize: 16, color: 'white',
              cursor: 'pointer', fontWeight: 700, boxShadow: '0 6px 20px rgba(99,102,241,0.4)',
            }}>
              7 Gün Ücretsiz Başla →
            </button>
            <a href="mailto:info@reseptio.com?subject=Demo İsteği" style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              borderRadius: 12, padding: '14px 28px', fontSize: 16, color: '#6366f1',
              border: '2px solid #6366f1', textDecoration: 'none', fontWeight: 700,
            }}>
              📧 Demo İsteyin
            </a>
          </div>
          <div style={{ display: 'flex', gap: 24, marginTop: 32, flexWrap: 'wrap' }}>
            {['Kredi kartı gerekmez', '7 gün ücretsiz deneme', '5 dakikada kurulum'].map(t => (
              <div key={t} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#64748b', fontWeight: 600 }}>
                <span style={{ color: '#10b981' }}>✓</span> {t}
              </div>
            ))}
          </div>
        </div>

        {/* Demo Bot */}
        <div style={{ flex: '0 0 420px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }} className="fade-up">
          <div style={{ fontSize: 12, fontWeight: 700, color: '#7c3aed', background: '#ede9fe', padding: '4px 12px', borderRadius: 20, marginBottom: 4 }}>
            🎮 Canlı Demo — Kayıt Gerektirmez
          </div>
          <DemoBot />
          <p style={{ fontSize: 11, color: '#94a3b8', textAlign: 'center' }}>
            Demo: Marina Butik Otel (Kurgusal) · Oturum başı 10 mesaj
          </p>
        </div>
      </section>

      {/* NASIL ÇALIŞIR */}
      <section style={{ padding: '80px 32px', background: 'white' }}>
        <div style={{ maxWidth: 960, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 36, fontWeight: 900, marginBottom: 12 }}>Nasıl Çalışır?</h2>
          <p style={{ color: '#64748b', fontSize: 16, marginBottom: 48 }}>Kurulumdan canlıya 5 adım</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 24 }}>
            {[
              { step: '01', icon: '📝', title: 'Kaydol', desc: 'E-posta + telefon doğrulamasıyla 2 dakikada hesap aç' },
              { step: '02', icon: '📋', title: 'Oteli Tanımla', desc: 'Odaları, fiyatları ve SSS\'leri gir' },
              { step: '03', icon: '📱', title: 'Kanalı Bağla', desc: 'WhatsApp veya Instagram\'ı 1 tıkla bağla' },
              { step: '04', icon: '🤖', title: 'Botu Eğit', desc: 'Kişilik, ton ve özel bilgi ekle' },
              { step: '05', icon: '🚀', title: 'Canlıya Al', desc: 'Bot artık 7/24 misafirlerinle konuşuyor' },
            ].map(item => (
              <div key={item.step} className="feature-card" style={{
                background: '#f8fafc', borderRadius: 16, padding: '24px 20px', textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>{item.icon}</div>
                <div style={{ fontSize: 11, fontWeight: 800, color: '#6366f1', marginBottom: 8, letterSpacing: '0.1em' }}>ADIM {item.step}</div>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 8, color: '#1e293b' }}>{item.title}</div>
                <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ÖZELLİKLER */}
      <section style={{ padding: '80px 32px', background: 'linear-gradient(135deg, #f8f7ff, #f0f9ff)' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 style={{ fontSize: 36, fontWeight: 900, marginBottom: 12 }}>Neler Yapabilir?</h2>
            <p style={{ color: '#64748b', fontSize: 16 }}>Reseptio sadece soru cevaplamaz — satış yapar</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
            {[
              { icon: '💬', title: 'Çoklu Dil', desc: 'Türkçe, İngilizce ve 30+ dilde misafirlerinizle konuşur' },
              { icon: '📅', title: 'Rezervasyon Toplama', desc: 'Tarih, kişi sayısı, oda tercihini alır ve size iletir' },
              { icon: '📸', title: 'Oda Görselleri', desc: 'Müşteri sordukça oda fotoğraflarını otomatik gönderir' },
              { icon: '🕐', title: '7/24 Yanıt', desc: 'Gece 03:00\'te gelen soruya da 3 saniyede cevap verir' },
              { icon: '👤', title: 'Canlıya Devir', desc: 'Gerektiğinde konuşmayı resepsiyonistle paylaşır' },
              { icon: '📊', title: 'Analitik', desc: 'Hangi sorular çok soruluyor, dönüşüm oranınız nedir?' },
            ].map(f => (
              <div key={f.title} className="feature-card" style={{
                background: 'white', borderRadius: 16, padding: '24px 20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              }}>
                <div style={{ fontSize: 28, marginBottom: 12 }}>{f.icon}</div>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 8, color: '#1e293b' }}>{f.title}</div>
                <div style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PİLOT */}
      <section style={{ padding: '60px 32px', background: 'white' }}>
        <div style={{ maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 28, fontWeight: 900, marginBottom: 32, color: '#0f172a' }}>Pilot Çalışmamız</h2>
          <div style={{
            background: '#f8f7ff', border: '1px solid #e0e7ff', borderRadius: 16,
            padding: '28px 32px', textAlign: 'left', maxWidth: 520, margin: '0 auto',
            display: 'flex', gap: 20, alignItems: 'flex-start',
          }}>
            <div style={{ fontSize: 36, flexShrink: 0 }}>📍</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16, color: '#1e293b', marginBottom: 6 }}>
                Aksoy Otel (Bozcaada)
              </div>
              <div style={{ fontSize: 14, color: '#475569', lineHeight: 1.6 }}>
                Aksoy Otel ile pilot çalışmamız sürüyor — ilk sonuçları yakında burada paylaşacağız.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GÜVEN / SSS */}
      <section style={{ padding: '80px 32px', background: 'linear-gradient(135deg, #f8f7ff, #f0f9ff)' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{ fontSize: 28, fontWeight: 900, marginBottom: 40, textAlign: 'center', color: '#0f172a' }}>Sık Sorulan Sorular</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {[
              {
                q: 'Verilerim güvende mi?',
                a: 'Sunucularımız Avrupa Birliği\'nde (Almanya), KVKK ve GDPR standartlarına uygun veri merkezlerinde barındırılıyor. Tüm veriler şifreli iletilir ve saklanır.',
              },
              {
                q: 'Sistem ne kadar erişilebilir?',
                a: 'Yüksek erişilebilirlik hedefliyoruz; olası kesintilerde ekibimiz anında müdahale eder.',
              },
              {
                q: 'Kayıt için kredi kartı gerekiyor mu?',
                a: 'Hayır. 7 günlük ücretsiz deneme için yalnızca e-posta ve telefon doğrulaması yeterli.',
              },
              {
                q: 'Bot hangi dillerde yanıt verebilir?',
                a: 'Türkçe ve İngilizce başta olmak üzere, misafirin yazdığı dili otomatik algılayıp o dilde yanıt verir.',
              },
              {
                q: 'WhatsApp entegrasyonu nasıl çalışıyor?',
                a: 'QR kod ile kendi WhatsApp hattınızı bağlayabilirsiniz. Meta Business API ile de kurumsal bağlantı desteklenmektedir.',
              },
            ].map((item, i) => (
              <details key={i} style={{ background: 'white', borderRadius: 12, padding: '18px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', cursor: 'pointer' }}>
                <summary style={{ fontWeight: 700, fontSize: 15, color: '#1e293b', listStyle: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  {item.q}
                  <span style={{ color: '#6366f1', fontSize: 18, flexShrink: 0 }}>+</span>
                </summary>
                <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, marginTop: 12, marginBottom: 0 }}>{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* FİYATLANDIRMA */}
      <section style={{ padding: '80px 32px', background: 'white' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 36, fontWeight: 900, marginBottom: 12 }}>Size Özel Fiyatlandırma</h2>
          <p style={{ color: '#64748b', fontSize: 16, marginBottom: 48 }}>
            Otelinizin büyüklüğüne, mesaj hacmine ve ihtiyacınıza göre özelleştirilmiş fiyat teklifi sunuyoruz.
            Genel bir tarife yerine sizi dinleyip gerçek değer öneriyoruz.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20, marginBottom: 48 }}>
            {[
              { plan: 'Starter', desc: 'Küçük butik oteller için', features: ['WhatsApp entegrasyonu', 'Temel analitik', 'E-posta destek'] },
              { plan: 'Pro', desc: 'Büyüyen oteller için', features: ['WhatsApp + Instagram', 'Oda görselleri', 'iCal senkronizasyon', 'Öncelikli destek'], highlight: true },
              { plan: 'Kurumsal', desc: 'Zincir ve resort oteller', features: ['Tüm özellikler', 'Özel entegrasyon', 'Dedicated destek', 'SLA garantisi'] },
            ].map(p => (
              <div key={p.plan} style={{
                background: p.highlight ? 'linear-gradient(135deg, #6366f1, #8b5cf6)' : '#f8fafc',
                borderRadius: 20, padding: '28px 24px',
                boxShadow: p.highlight ? '0 8px 32px rgba(99,102,241,0.3)' : '0 2px 8px rgba(0,0,0,0.06)',
              }}>
                <div style={{ fontWeight: 900, fontSize: 20, color: p.highlight ? 'white' : '#1e293b', marginBottom: 6 }}>{p.plan}</div>
                <div style={{ fontSize: 13, color: p.highlight ? 'rgba(255,255,255,0.8)' : '#64748b', marginBottom: 20 }}>{p.desc}</div>
                <div style={{ fontSize: 22, fontWeight: 900, color: p.highlight ? 'white' : '#6366f1', marginBottom: 20 }}>
                  Teklif Alın
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
                  {p.features.map(f => (
                    <li key={f} style={{ fontSize: 13, color: p.highlight ? 'rgba(255,255,255,0.9)' : '#475569', padding: '4px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ color: p.highlight ? 'rgba(255,255,255,0.9)' : '#10b981' }}>✓</span> {f}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <a href="mailto:info@reseptio.com?subject=Fiyat Teklifi İsteği" className="cta-btn" style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', border: 'none',
            borderRadius: 12, padding: '16px 36px', fontSize: 16, color: 'white',
            cursor: 'pointer', fontWeight: 700, textDecoration: 'none',
            boxShadow: '0 6px 20px rgba(99,102,241,0.4)',
          }}>
            📧 Demo İsteyin — info@reseptio.com
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ background: '#0f172a', color: '#94a3b8', padding: '40px 32px', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
          <ReseptioLogoFull height={30} style={{ filter: 'brightness(0) invert(1)' }} />
        </div>
        <p style={{ fontSize: 14, marginBottom: 16 }}>Otelinizin 7/24 Çalışan Dijital Resepsiyonisti</p>
        <div style={{ display: 'flex', gap: 24, justifyContent: 'center', fontSize: 13, flexWrap: 'wrap' }}>
          <a href="mailto:info@reseptio.com" style={{ color: '#94a3b8', textDecoration: 'none' }}>info@reseptio.com</a>
          <span onClick={() => navigate('/login')} style={{ cursor: 'pointer', color: '#94a3b8' }}>Giriş Yap</span>
          <span onClick={() => navigate('/register')} style={{ cursor: 'pointer', color: '#6366f1' }}>Ücretsiz Başla</span>
        </div>
        <p style={{ fontSize: 12, marginTop: 20, color: '#475569' }}>© 2026 Reseptio. Tüm hakları saklıdır.</p>
      </footer>
    </div>
  );
}
